/** Pilha de handlers Esc — o último aberto fecha primeiro (preview → drawer → página). */
const layers = []

function onEscapeKeydown(event) {
  if (event.key !== 'Escape' || layers.length === 0) return
  event.preventDefault()
  event.stopImmediatePropagation()
  const close = layers[layers.length - 1]
  if (typeof close === 'function') close()
}

window.addEventListener('keydown', onEscapeKeydown, true)

/**
 * Registra camada que fecha com Esc (ex.: preview de imagem).
 * @returns {() => void} remover da pilha
 */
export function pushEscapeLayer(closeFn) {
  layers.push(closeFn)
  return () => {
    const index = layers.lastIndexOf(closeFn)
    if (index >= 0) layers.splice(index, 1)
  }
}

export function hasEscapeLayers() {
  return layers.length > 0
}
